import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "return-to-container" }

import { onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "@/axiosInstance";
import { API_URL, EDITOR_BASE_URL } from "@/config";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReturnTo',
  setup(__props) {

const route = useRoute();

onMounted(async () => {
	const returnTo = route.query.returnTo as string | undefined;

	if (!returnTo) {
		// Se non c'è returnTo, vai alla dashboard
		window.location.href = "/dashboard";
		return;
	}

	try {
		const API_BASE = (API_URL || "").replace(/\/$/, "");
		const editorBase = new URL(
			EDITOR_BASE_URL || "https://d12f-151-74-127-120.ngrok-free.app",
		);

		// Ottieni il ticket
		const response = await axios.get(
			`${API_BASE}/auth/editor/ticket?returnTo=${returnTo}`,
		);
		const ticketId = response.data.ticketId;

		console.log("ticket =", ticketId);

		// Costruisci l'URL dell'editor e redirecta
		const editorSchemaUrl = new URL(`/sso/${ticketId}`, editorBase).toString();

		// Mostra la pagina per un attimo prima di reindirizzare
		setTimeout(() => {
			window.location.href = editorSchemaUrl;
		}, 2000);
	} catch (error) {
		console.error("Errore durante il redirect all'editor:", error);
		// In caso di errore, redirecta alla dashboard
		window.location.href = "/dashboard";
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "loading-spinner" }, [
      _createElementVNode("div", { class: "spinner" }),
      _createElementVNode("p", null, "Utente già autenticato. Reindirizzamento all'editor in corso...")
    ], -1)
  ]))]))
}
}

})